// some widgets, when at the top or bottom of a section, should make their
// containing sections exhibit the same behavior as when the section has a background,
// that is, there should not show a gap between two sections with a background
$('.full-bleed').each(function () {
    if ($(this).is(':first-child'))
        $(this).closest('.section').addClass('section__noTopMargin');
    if ($(this).is(':last-child'))
        $(this).closest('.section').addClass('section__noBottomMargin');
});

$('.full-bleed-top').each(function () {
    if ($(this).is(':first-child'))
        $(this).closest('.section').addClass('section__noTopMargin');
});

$('.widget-area').each(function () {
    if ($('.section-body > *', this).length == 0)
        $(this).addClass('no-widgets');
});
